/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { environment } from '../../../environments/environment';

@Injectable()
export class UsersService {
	private groupUrl: string = environment.host + '/groups/';
	private fetchGroupUrl: string = environment.host + '/group/';
	private userUrl = environment.host + "/user";
	private createUrl = environment.host + "/users";
	private permissionsMetadataUrl = environment.host + "/permission/metadata";
	private copyFromGroupDetails = {};
	private moveFromGroupDetails = {};
	private selectedUserDetails: any;
	private action: any;
	private duplicateMoveUserObj: any;

	constructor(private http: HttpClient) { }

	public setSelectedUserDetails(selectedUserDetails: any) {
		this.selectedUserDetails = selectedUserDetails;
	}

	public getSelectedUserDetails() {
		return this.selectedUserDetails;
	}

	public setSeletedAction(action: any) {
		this.action = action;
	}

	public getSeletedAction() {
		return this.action;
	}

	public getAllUsers() {
		return this.http.get(this.userUrl).toPromise();
	}

	public getAllGroups() {
		return this.http.get(this.fetchGroupUrl).toPromise();
	}

	public saveGroups(userObj: Array<any>) {
		return this.http.post(this.groupUrl, userObj).toPromise();
	}

	public saveUsers(userObj: Array<any>) {
		return this.http.post(this.createUrl, userObj).toPromise();
	}

	public setCopyFromGroupDetails(item: any) {
		this.copyFromGroupDetails = item;
	}

	public getCopyFromGroupDetails() {
		return this.copyFromGroupDetails;
	}

	public setMoveFromGroupDetails(item: any) {
		this.moveFromGroupDetails = item;
	}

	public getMoveFromGroupDetails() {
		return this.moveFromGroupDetails;
	}

	public removeUsersFromGroup(userObj: any) {
		return this.http.post(this.groupUrl, userObj).toPromise();
	}

	public deleteUserFromGroup(userObj: any) {
		return this.http.post(this.createUrl, userObj).toPromise();
	}

	public getHomePageMetaData() {
		const url = environment.host + '/homePage';
		return this.http.get(url).toPromise();
	}

	public getAllDuplicateMoveUsers() {
		return this.duplicateMoveUserObj;
	}

	public setAllDuplicateMoveUsers(item: any) {
		this.duplicateMoveUserObj = item;
	}

	public getPermissionsMetadata(){
		return this.http.get(this.permissionsMetadataUrl).toPromise();
	}

	public getCompanyMetaData() {
		const url = environment.host + '/company?tabType=' + 'USP';
		return this.http.get(url).toPromise();
	}
}
